//include 9
jQuery(function(){

    var select = $(".meta-select");
    if (select.length == 0)
        return;
    var placeholder = select.attr("placeholder") || "";

    var selectData = [];
    select.find("option").each(function(){

        var isSelected = $(this).attr("value") == select.val();

        var data = {
            id: $(this).attr("value"),
            active: isSelected,
            count: $(this).data("count"),
            text: $(this).text()
        };
        selectData.push(data);
    });

    select.select2({
        data:selectData,
        placeholder: placeholder,
        minimumResultsForSearch: Infinity,
        templateResult: function(element){
            return $('<p class="meta-selection"><span>'+element.text+'</span><i>('+element.count+')</i></p>');
        },
        templateSelection: function(element){
            return $('<p class="meta-selection selected"><span>'+element.text+'</span><i>('+element.count+')</i></p>');
        }
    });

    select.on("change", function (e) {
        window.location.href=select.val();
     });


});